import React from 'react'
import { connect } from 'react-redux'
import { overlayActions } from 'store/overlay'
import { getUserScopeByStudy } from 'utils/misc'
import DataInboxPage from '../components/DataInboxPage'
import { actions } from '../modules/DataInbox'

const mapStateToProps = (state, ownProps) => {
  const { studyVersionID } = ownProps?.params || {}
  const { loading, searchTerm, study, dataInboxMaterial, user } = state
  const { currentStudy } = study

  return {
    canWrite: getUserScopeByStudy(user, currentStudy).includes('ft'),
    loading: loading.general,
    searchTerm,
    studyId: currentStudy.id,
    dataInboxMaterial,
    studyVersionID,
  }
}

const mapDispatchToProps = { ...actions, ...overlayActions }

export default connect(mapStateToProps, mapDispatchToProps)(props => <DataInboxPage {...props} />)
